<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

defineProps({
  document: { type: Object, default: null },
  canRemove: { type: Boolean, default: false },
  canUpload: { type: Boolean, default: false },
  removing: { type: Boolean, default: false },
  uploading: { type: Boolean, default: false },
});

const emit = defineEmits(['download', 'remove', 'upload']);
const { t } = useI18n();
const fileInput = ref(null);

const selectFile = () => fileInput.value?.click();
const upload = event => {
  const [file] = event.target.files || [];
  if (file) emit('upload', file);
  event.target.value = '';
};
</script>

<template>
  <div class="grid gap-4">
    <div
      v-if="document"
      class="flex flex-wrap items-center justify-between gap-3 rounded-lais-sm bg-lais-bg-soft p-4"
    >
      <div class="min-w-0">
        <p class="truncate text-sm font-semibold text-lais-text">
          {{ document.filename }}
        </p>
        <p class="mt-1 text-xs text-lais-text-muted">
          {{ document.content_type }}
        </p>
      </div>
      <div class="flex flex-wrap gap-2">
        <LaisPrimaryButton
          size="sm"
          variant="ghost"
          icon="i-lucide-download"
          @click="emit('download')"
        >
          {{ t('SALES.DETAIL.RECEIPT.DOWNLOAD') }}
        </LaisPrimaryButton>
        <LaisPrimaryButton
          v-if="canRemove"
          size="sm"
          variant="ghost"
          icon="i-lucide-trash-2"
          :is-loading="removing"
          @click="emit('remove')"
        >
          {{ t('SALES.DETAIL.RECEIPT.REMOVE') }}
        </LaisPrimaryButton>
      </div>
    </div>
    <p v-else class="text-sm text-lais-text-muted">
      {{ t('SALES.DETAIL.RECEIPT.NO_FILE') }}
    </p>

    <div v-if="canUpload">
      <input
        ref="fileInput"
        type="file"
        class="hidden"
        accept=".doc,.docx,.pdf,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        @change="upload"
      />
      <LaisPrimaryButton
        icon="i-lucide-upload"
        :is-loading="uploading"
        @click="selectFile"
      >
        {{
          document
            ? t('SALES.DETAIL.RECEIPT.REPLACE')
            : t('SALES.DETAIL.RECEIPT.UPLOAD')
        }}
      </LaisPrimaryButton>
    </div>
  </div>
</template>
